import { Expose, Type } from 'class-transformer';
import { SurveyElementsUnion } from './survey-elements-union';
import { SurveyElement, SurveyGroupingElement } from '@/models/survey-elements';
import { BaseDiscriminatorConfig } from '@/models/survey-elements/survey-element-discriminator';
import { COMPONENT_TYPES } from '@/models/enums/component-types.enum';

type NextViewElement = {
  type: string;
  text: string;
};
export class Elements {
  @Type(() => SurveyElement, {
    discriminator: {
      property: 'element_type',
      subTypes: [
        ...BaseDiscriminatorConfig(),
        {
          value: SurveyGroupingElement,
          name: COMPONENT_TYPES.GROUPING_ELEMENT,
        },
      ],
    },
    keepDiscriminatorProperty: true,
  })
  elements!: SurveyElementsUnion[];
  @Expose({ name: 'next_view_element' })
  nextViewElement?: NextViewElement;
}

export class Progress {
  @Expose({ name: 'current_step' })
  currentStep!: number;

  @Expose({ name: 'total_steps' })
  totalSteps!: number;
}

export class Survey {
  @Expose()
  id!: string;

  @Expose({ name: 'is_next_view' })
  isNextView!: boolean;

  @Expose({ name: 'is_next_view_button_visible' })
  showSubmitButton!: boolean;

  @Expose({ name: 'active_view' })
  @Type(() => Elements)
  activeView!: Elements;

  @Expose({ name: 'active_branch_identifier' })
  activeBranchIdentifier!: string;

  @Expose({ name: 'active_view_name' })
  activeViewName!: string | null;

  @Expose({ name: 'progress' })
  @Type(() => Progress)
  progress!: Progress;
}
